import { put, select, takeEvery } from 'redux-saga/effects';

import { GlobalActionTypes } from '@/store/reducers/global/action-types';
import { openTrainingRequiredModal } from '@/store/reducers/global/actions';
import { selectIsUserAuthorizedToSell } from '@/store/reducers/user/selectors';
import { ReduxAction, ReduxActionChain } from '@/types';

function* openSubmitOrderModalHandler(action: ReduxAction) {
  if (!(yield select(selectIsUserAuthorizedToSell))) {
    yield put(openTrainingRequiredModal());

    return;
  }

  yield put({ ...action, type: GlobalActionTypes.SUBMIT_ORDER_MODAL.OPEN });
}

export function* GeneralSaga() {
  yield takeEvery(GlobalActionTypes.SUBMIT_ORDER_MODAL.TRY_OPEN, openSubmitOrderModalHandler);
  yield takeEvery(GlobalActionTypes.ACTION_CHAIN, function* ({ actions }: ReduxActionChain) {
    for (const action of actions) yield put(action);
  });
}
